module.exports = __webpack_public_path__ + "img/qq_small.0f60b701.jpg";